import React from 'react';
import classNames from 'classnames';

import css from './IconCross.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element}
 */
const IconCross = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 1.00004L1 11M0.999958 1L10.9999 11" stroke-width="1.2" stroke-linecap="round" />
    </svg>
  );
};

export default IconCross;
